// extracted by mini-css-extract-plugin
export default {"header_large":"PopupHeaderComponent_header_large__Xy1Qb","header":"PopupHeaderComponent_header__nGxgT"};